export enum StoredCredentialType {
  SignUp = 'SIGNUP',
  Charge = 'CHARGE',
}
